import axiosService from 'services/axiosService';
import { SSO_ENDPOINT } from 'constants';
const url = 'ssos/v1';

export const track_activities = params => {
  return axiosService.post(`${SSO_ENDPOINT}/${url}/track_activities`, params);
};
